export default __webpack_public_path__ + "static/media/newsletter.10386ac8.svg";